module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shopItems) ? _c('section', [_c('div', {
    staticClass: "shop container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "moduleItems"
  }, _vm._l((_vm.shopItems), function(item) {
    return _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.link || 'https://www.podswag.com/collections/longest-shortest-time'
      }
    }, [_c('span', {
      staticClass: "img",
      style: ({
        backgroundImage: ("url(" + (_vm.featured(item.image)) + ")")
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "shopContent"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.price)
      }
    })])])
  }))])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circleHeader"
  }, [_c('h2', [_vm._v("Shop our store"), _c('br'), _vm._v("\n        and support the show!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73850404"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ShopModule.vue
// module id = 792
// module chunks = 1